import { SHButton, SHButtonProps } from "@components/design-systems";
import { DeleteSVG } from "@components/svgs";
import { DELAY_TIME } from "@constants";
import { Tooltip, useTheme } from "@mui/material";
interface ArchiveButtonProps extends SHButtonProps {}
export const ArchiveButton = ({ ...props }: ArchiveButtonProps) => {
  const { palette } = useTheme();
  return (
    <Tooltip title="Archive" enterDelay={DELAY_TIME}>
      <SHButton
        {...props}
        sx={{
          padding: "5px",
          "&:active": {
            "&>svg>path": {
              fill: palette.common.white,
            },
          },
        }}
        variant="outlined"
      >
        <DeleteSVG
          color={props.disabled ? palette.grey[600] : palette.common.black}
        />
      </SHButton>
    </Tooltip>
  );
};
